const labelMap: any = {
  '10554': {
    Features: {
      0: 'UnspecifiedSupportedFlag',
      1: 'IdleStartFeatureSupportedFlag',
      2: 'OperatorIdFeatureSupportedFlag',
      3: 'AdvancedProductivityFeatureSupportedFlag',
      4: 'TotalFuelPl542SupportedFlag',
      5: 'FuelLevelPl542SupportedFlag',
      6: 'ThingworxSupportedFlag',
      7: 'SystemSecurityTamperSupportedFlag',
      8: 'WifiInfrastructureModeSupportedFlag',
      9: 'WifiHotSpotSupportedFlag',
      10: 'WifiSimultaneousSupportedFlag',
      11: 'RealTimeDataStreamingWithExceptionReportingSupportedFlag',
      12: 'HigherMemoryTrA5OrA6DetectedSupportedFlag',
      13: 'ThirdPartyWifiRadioDetectedSupportedFlag',
      14: 'PortConfiguredForCatGradeControlSupportedFlag',
      15: 'WorkOrderAssistSupportedFlag',
      16: 'RealTimeDataStreamingWithExceptionDeadbandFlag'
    },
  },
};

export const getAllLabels = (fileType: string, key: string) => {
  if (labelMap[fileType] && labelMap[fileType][key]) {
    return labelMap[fileType][key];
  }
  return [];
};

export const getDisplayValue = (messageType: string, key: string, value: number, index: number) => {
  if (labelMap[messageType] && labelMap[messageType][key] && labelMap[messageType][key][value]) {
    return labelMap[messageType][key][value];
  }
  return `${key}-${index}`;
};

export const hasDisplayValue = (fileType: string, key: string) => {
  if (labelMap[fileType] && labelMap[fileType][key]) return true;
  return false;
};

export const messageTypeHasStaticDisplay = (fileType: string) => fileType in labelMap;

export const getKeysForFileType = (fileType: string) => Object.keys(labelMap[fileType]);
